import { Trans } from '@lingui/react/macro';

import type { ZuubGeneralDisclaimer } from '@/@types/zuub/contracts';

interface GeneralDisclaimersListProps {
  disclaimers: ZuubGeneralDisclaimer[];
}

export const GeneralDisclaimersList = ({
  disclaimers,
}: GeneralDisclaimersListProps) => {
  if (disclaimers.length === 0) {
    return null;
  }

  return (
    <div className="vai-space-y-3">
      <h3 className="vai-text-lg vai-font-semibold vai-text-foreground">
        <Trans>General Disclaimers</Trans>
      </h3>
      <ul className="vai-space-y-2 vai-list-disc vai-list-inside">
        {disclaimers.map((disclaimer, index) => (
          <li
            key={`${disclaimer.type}-${index}`}
            className="vai-text-sm vai-text-foreground"
          >
            {disclaimer.text}
          </li>
        ))}
      </ul>
    </div>
  );
};
